module.exports = __webpack_public_path__ + "static/media/game-marksfont.c8ba62f7.png";